export const playbackRateCLickedEvent = 'playbackRateCLicked';
